import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';

import moment from 'moment';
import PropTypes from 'prop-types';
import Main from 'pages/layout/main';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

const App = ({ history }) => (
    <Router history={history}>
        <Switch>
            <Route path="/" component={Main} />
        </Switch>
    </Router>
);

App.propTypes = {
    history: PropTypes.shape({}).isRequired,
};

export default App;
